import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconChat({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="#F4F4F4">
				<path d="M21.22 9.503c-.316 4.59-4.884 8.247-10.47 8.247q-.611-.002-1.22-.063c1.762 1.388 4.322 2.079 6.953 1.721l4.767 2.383v-4.563C22.381 16.14 23 14.785 23 13.375c0-1.424-.633-2.78-1.78-3.872" />
				<path d="M10.75 2C5.917 2 2 5.134 2 9c0 1.572.656 3.019 1.75 4.187v4.563l4.229-2.114c.871.233 1.801.364 2.771.364 4.833 0 8.75-3.134 8.75-7s-3.917-7-8.75-7" />
			</g>
		</svg>
	);
}
